{
  "createUser": {
    "title": "Création de l'utilisateur"
  },
  "editUser": {
    "title": "Modifier un utilisateur"
  },
  "selectUserProfileEdit": {
    "title": "Associer à un profil"
  },
  "userGroups": {
    "title": "Associer des groupes"
  }
}
